import React, { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Grid,
  TextField,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Button,
  Typography,
  Paper,
  Divider,
  IconButton,
  Badge,
  Chip,
  FormControl, // Added
  InputLabel, // Added
  Select, // Added
  MenuItem, // Added
} from '@mui/material';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SearchIcon from '@mui/icons-material/Search';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';


// --- Dummy Data with Season and Type ---
const tireInventoryData = [
  { id: 'T001', brand: 'Michelin', model: 'CrossClimate 2', size: '225/45R17 94V XL', price: 215.99, quantityAvailable: 25, imageUrl: 'https://m.media-amazon.com/images/I/81K8ka7r70L._AC_UY327_FMwebp_QL65_.jpg', season: 'All-Season', type: 'Passenger Car' },
  { id: 'T002', brand: 'Goodyear', model: 'Assurance WeatherReady', size: '215/55R17 94V', price: 190.50, quantityAvailable: 15, imageUrl: 'https://m.media-amazon.com/images/I/61Z1r5XZyKL._AC_UY327_FMwebp_QL65_.jpg', season: 'All-Season', type: 'Passenger Car' },
  { id: 'T003', brand: 'Continental', model: 'PureContact LS', size: '235/50R18 97V', price: 205.00, quantityAvailable: 30, imageUrl: 'https://m.media-amazon.com/images/I/71XU7kQ-YDL._AC_UY327_FMwebp_QL65_.jpg', season: 'All-Season', type: 'Passenger Car' },
  { id: 'T004', brand: 'Bridgestone', model: 'Turanza QuietTrack', size: '205/60R16 92H', price: 185.75, quantityAvailable: 10, imageUrl: 'https://m.media-amazon.com/images/I/81sM0+NFNpL._AC_UY327_FMwebp_QL65_.jpg', season: 'All-Season', type: 'Passenger Car' },
  { id: 'T005', brand: 'Pirelli', model: 'Cinturato P7 All Season Plus II', size: '245/40R19 98W XL', price: 250.00, quantityAvailable: 18, imageUrl: 'https://m.media-amazon.com/images/I/61-YhLqF7WL._AC_UY327_FMwebp_QL65_.jpg', season: 'All-Season', type: 'Passenger Car' },
  { id: 'T006', brand: 'Hankook', model: 'Kinergy PT (H737)', size: '195/65R15 91H', price: 115.80, quantityAvailable: 40, imageUrl: 'https://m.media-amazon.com/images/I/61KzY-a8pQL._AC_UY327_FMwebp_QL65_.jpg', season: 'All-Season', type: 'Passenger Car' },
  { id: 'T007', brand: 'Yokohama', model: 'Avid Ascend GT', size: '225/50R17 98V XL', price: 165.00, quantityAvailable: 22, imageUrl: 'https://m.media-amazon.com/images/I/81B3n4K7Q7L._AC_UY327_FMwebp_QL65_.jpg', season: 'All-Season', type: 'Passenger Car' },
  { id: 'T008', brand: 'Falken', model: 'ZIEX ZE960 A/S', size: '215/45R17 91W XL', price: 130.00, quantityAvailable: 12, imageUrl: 'https://www.falkentyre.com/__image/a/668070/alias/xl/v/3/c/29/ar/flexible/fn/Falken%20ZIEX%20ZE320.jpg', season: 'All-Season', type: 'Performance' },
  { id: 'T009', brand: 'Michelin', model: 'Pilot Sport 4S', size: '245/35R20 95Y XL', price: 350.99, quantityAvailable: 8, imageUrl: 'https://m.media-amazon.com/images/I/61u+yubX18L._AC_UY327_FMwebp_QL65_.jpg', season: 'Summer', type: 'Performance' },
  { id: 'T010', brand: 'Bridgestone', model: 'Blizzak WS90', size: '215/60R16 95H', price: 155.00, quantityAvailable: 18, imageUrl: 'https://m.media-amazon.com/images/I/81wQ1lF0m7L._AC_UY327_FMwebp_QL65_.jpg', season: 'Winter', type: 'Passenger Car' },
  { id: 'T011', brand: 'BFGoodrich', model: 'All-Terrain T/A KO2', size: 'LT275/70R17 112/109R C', price: 280.00, quantityAvailable: 14, imageUrl: 'https://m.media-amazon.com/images/I/71S40k+jXEL._AC_UY327_FMwebp_QL65_.jpg', season: 'All-Season', type: 'SUV/Truck' },
  { id: 'T012', brand: 'Nokian', model: 'Hakkapeliitta R3', size: '205/55R16 94R XL', price: 175.00, quantityAvailable: 20, imageUrl: 'https://m.media-amazon.com/images/I/81nZ3Pq5yPL._AC_UY327_FMwebp_QL65_.jpg', season: 'Winter', type: 'Passenger Car' },
  { id: 'T013', brand: 'Cooper', model: 'Discoverer AT3 4S', size: '265/70R17 115T', price: 220.50, quantityAvailable: 9, imageUrl: 'https://m.media-amazon.com/images/I/71x6C2xOqQL._AC_UY327_FMwebp_QL65_.jpg', season: 'All-Season', type: 'SUV/Truck' },
];
// ------------------------------------

const orderHistoryData = [
  { id: 'ORD-H1A-001', date: '2023-10-25', items: [{ brand: 'Michelin', model: 'CrossClimate 2', quantity: 4 }], total: 863.96, status: 'Delivered' },
  { id: 'ORD-H1A-002', date: '2023-10-22', items: [{ brand: 'Goodyear', model: 'Assurance WeatherReady', quantity: 2 }], total: 381.00, status: 'Shipped' },
  { id: 'ORD-H1A-003', date: '2023-10-18', items: [{ brand: 'Hankook', model: 'Kinergy PT (H737)', quantity: 4 }], total: 463.20, status: 'Delivered' },
  { id: 'ORD-H1A-004', date: '2023-11-01', items: [{ brand: 'Pirelli', model: 'Cinturato P7', quantity: 1 }], total: 250.00, status: 'Processing' },
  { id: 'ORD-H1A-005', date: '2023-11-02', items: [{ brand: 'Continental', model: 'PureContact LS', quantity: 4 }], total: 820.00, status: 'Processing' },
];

const getStatusColor = (status) => {
  switch (status) {
    case 'Shipped': return 'info';
    case 'Processing': return 'warning';
    case 'Delivered': return 'success';
    case 'Cancelled': return 'error';
    default: return 'default';
  }
};

// Get unique values for filters
const tireSeasons = ['All', ...new Set(tireInventoryData.map(tire => tire.season))];
const tireTypes = ['All', ...new Set(tireInventoryData.map(tire => tire.type))];


const VlnOrder = ({ _ }) => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedSeason, setSelectedSeason] = useState('All'); // Added State
  const [selectedType, setSelectedType] = useState('All');     // Added State
  const [cart, setCart] = useState([]);
  const [inventory] = useState(tireInventoryData);
  const [history] = useState(orderHistoryData);

  const elementData = useSelector(
    (state) => state.element.singleElementDetails
  );

  // --- Updated Filter Logic ---
  const filteredInventory = useMemo(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
    return inventory.filter(
      (tire) =>
        // Search Term Filter
        (tire.brand.toLowerCase().includes(lowerSearchTerm) ||
          tire.model.toLowerCase().includes(lowerSearchTerm) ||
          tire.size.toLowerCase().includes(lowerSearchTerm)) &&
        // Season Filter
        (selectedSeason === 'All' || tire.season === selectedSeason) &&
        // Type Filter
        (selectedType === 'All' || tire.type === selectedType)
    );
  }, [searchTerm, inventory, selectedSeason, selectedType]); // Added dependencies
  // --------------------------

  const handleAddToCart = (tire) => {
    setCart((prevCart) => {
      const existingItemIndex = prevCart.findIndex(item => item.tire.id === tire.id);
      if (existingItemIndex > -1) {
        const updatedCart = [...prevCart];
        const currentQuantity = updatedCart[existingItemIndex].quantity;
        const availableQuantity = tire.quantityAvailable;
        if (currentQuantity < availableQuantity) {
          updatedCart[existingItemIndex].quantity += 1;
        } else {
          console.warn("Max quantity available reached for this item.")
        }
        return updatedCart;
      } else {
        if (tire.quantityAvailable > 0) {
          return [...prevCart, { tire, quantity: 1 }];
        } else {
          console.warn("Item out of stock.")
          return prevCart;
        }
      }
    });
  };

  const handleUpdateCartQuantity = (tireId, change) => {
    setCart((prevCart) => {
      const itemIndex = prevCart.findIndex(item => item.tire.id === tireId);
      if (itemIndex === -1) return prevCart;

      const updatedCart = [...prevCart];
      const newQuantity = updatedCart[itemIndex].quantity + change;
      const availableQuantity = updatedCart[itemIndex].tire.quantityAvailable;

      if (newQuantity <= 0) {
        updatedCart.splice(itemIndex, 1);
      } else if (newQuantity <= availableQuantity) {
        updatedCart[itemIndex].quantity = newQuantity;
      } else {
        console.warn("Max quantity available reached for this item.")
        updatedCart[itemIndex].quantity = availableQuantity;
      }
      return updatedCart;
    })
  }

  const handleRemoveFromCart = (tireId) => {
    setCart((prevCart) => prevCart.filter(item => item.tire.id !== tireId));
  }

  const cartTotalItems = useMemo(() => {
    return cart.reduce((total, item) => total + item.quantity, 0);
  }, [cart]);

  const cartTotalPrice = useMemo(() => {
    return cart.reduce((total, item) => total + (item.tire.price * item.quantity), 0);
  }, [cart]);

  return (
    <Box sx={{ display: 'flex', height: 'calc(100vh - 64px)', p: 1 }}> {/* Adjust height based on your layout */}
      {/* Inventory & Cart Panel (Approx 3/4 width) */}
      <Grid container spacing={1} sx={{ flexGrow: 1, width: '75%' }}>
        {/* Search, Filters, and Inventory List */}
        <Grid item xs={12} md={7} sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          {/* Search and Filter Section */}
          <Paper elevation={2} sx={{ p: 1.5, mb: 1 }}>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              placeholder={t('Search tires by brand, model, size...')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: <SearchIcon sx={{ mr: 1, color: 'text.secondary' }} />,
              }}
              sx={{ mb: 1.5 }} // Add margin below search
            />
            {/* Filter Dropdowns */}
            <Grid container spacing={1.5}>
              <Grid item xs={6}>
                <FormControl fullWidth size="small">
                  <InputLabel id="season-select-label">{t('Season')}</InputLabel>
                  <Select
                    labelId="season-select-label"
                    id="season-select"
                    value={selectedSeason}
                    label={t('Season')}
                    onChange={(e) => setSelectedSeason(e.target.value)}
                  >
                    {tireSeasons.map(season => (
                      <MenuItem key={season} value={season}>{t(season)}</MenuItem> // Assuming 'All' needs translation too
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth size="small">
                  <InputLabel id="type-select-label">{t('Type')}</InputLabel>
                  <Select
                    labelId="type-select-label"
                    id="type-select"
                    value={selectedType}
                    label={t('Type')}
                    onChange={(e) => setSelectedType(e.target.value)}
                  >
                    {tireTypes.map(type => (
                      <MenuItem key={type} value={type}>{t(type)}</MenuItem> // Assuming 'All' needs translation too
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Paper>

          {/* Inventory List */}
          <Paper elevation={2} sx={{ flexGrow: 1, overflowY: 'auto' }}>
            <List dense>
              {filteredInventory.map((tire) => (
                <ListItem
                  key={tire.id}
                  divider
                  secondaryAction={
                    <IconButton
                      edge="end"
                      aria-label="add-to-cart"
                      onClick={() => handleAddToCart(tire)}
                      disabled={tire.quantityAvailable <= 0 || (cart.find(item => item.tire.id === tire.id)?.quantity ?? 0) >= tire.quantityAvailable}
                      color="primary"
                      title={tire.quantityAvailable <= 0 ? t('Out of stock') : (cart.find(item => item.tire.id === tire.id)?.quantity ?? 0) >= tire.quantityAvailable ? t('Max available in cart') : t('Add to cart')}
                    >
                      <AddShoppingCartIcon />
                    </IconButton>
                  }
                >
                  <ListItemAvatar>
                    <Avatar variant="rounded" src={tire.imageUrl} alt={`${tire.brand} ${tire.model}`} sx={{ width: 50, height: 50 }} />
                  </ListItemAvatar>
                  <ListItemText
                    primary={`${tire.brand} ${tire.model}`}
                    secondary={
                      <Box component="span">
                        <Typography component="span" variant="body2" color="text.primary">
                          {tire.size}
                        </Typography>
                        <Typography component="span" variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                          {`Season: ${t(tire.season)} | Type: ${t(tire.type)}`}
                        </Typography>
                        <Typography component="span" variant="body2" color="text.secondary" sx={{ display: 'block' }}>
                          {`Price: $${tire.price.toFixed(2)} | Available: ${tire.quantityAvailable}`}
                        </Typography>
                      </Box>
                    }
                  />
                </ListItem>
              ))}
              {filteredInventory.length === 0 && (
                <ListItem>
                  <ListItemText primary={t('No tires found matching your criteria.')} sx={{ textAlign: 'center', color: 'text.secondary', py: 2 }} />
                </ListItem>
              )}
            </List>
          </Paper>
        </Grid>

        {/* Cart Panel */}
        <Grid item xs={12} md={5} sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <Paper elevation={2} sx={{ p: 1.5, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <ShoppingCartIcon color="primary" sx={{ mr: 1 }} />
              <Typography variant="h6">{t('Current Order Cart')}</Typography>
              <Badge badgeContent={cartTotalItems} color="secondary" sx={{ ml: 'auto', mr: 2 }} />
            </Box>
            <Divider sx={{ mb: 1 }} />
            <Box sx={{ flexGrow: 1, overflowY: 'auto', mb: 1 }}>
              <List dense>
                {cart.length === 0 && (
                  <ListItem>
                    <ListItemText primary={t('Your cart is empty.')} sx={{ textAlign: 'center', color: 'text.secondary', py: 2 }} />
                  </ListItem>
                )}
                {cart.map(item => (
                  <ListItem key={item.tire.id} divider secondaryAction={
                    <IconButton edge="end" aria-label="delete" onClick={() => handleRemoveFromCart(item.tire.id)} size="small" title={t('Remove item')}>
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  }>
                    <ListItemAvatar sx={{ minWidth: 'auto', mr: 1.5 }}>
                      <Avatar variant="rounded" src={item.tire.imageUrl} sx={{ width: 40, height: 40 }} />
                    </ListItemAvatar>
                    <ListItemText
                      primaryTypographyProps={{ variant: 'body2', noWrap: true, title: `${item.tire.brand} ${item.tire.model}` }}
                      secondaryTypographyProps={{ variant: 'caption' }}
                      primary={`${item.tire.brand} ${item.tire.model}`}
                      secondary={`${item.tire.size} - $${item.tire.price.toFixed(2)}`}
                      sx={{ flexGrow: 1, mr: 1 }}
                    />
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <IconButton size="small" onClick={() => handleUpdateCartQuantity(item.tire.id, -1)} title={t('Decrease quantity')}>
                        <RemoveCircleOutlineIcon fontSize="small" />
                      </IconButton>
                      <Typography sx={{ mx: 0.5, minWidth: '20px', textAlign: 'center' }}>{item.quantity}</Typography>
                      <IconButton
                        size="small"
                        onClick={() => handleUpdateCartQuantity(item.tire.id, 1)}
                        disabled={item.quantity >= item.tire.quantityAvailable}
                        title={item.quantity >= item.tire.quantityAvailable ? t('Max available reached') : t('Increase quantity')}
                      >
                        <AddCircleOutlineIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  </ListItem>
                ))}
              </List>
            </Box>
            <Divider sx={{ mt: 'auto' }} />
            <Box sx={{ p: 1, mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="h6">{t('Total:')}</Typography>
              <Typography variant="h6" fontWeight="bold">{`$${cartTotalPrice.toFixed(2)}`}</Typography>
            </Box>
            <Button variant="contained" fullWidth disabled={cart.length === 0}>
              {t('Place Order')}
            </Button>
          </Paper>
        </Grid>
      </Grid>

      {/* History Panel (Approx 1/4 width) - Reactivated */}
      {/* <Paper elevation={2} sx={{ width: '25%', height: '100%', display: 'flex', flexDirection: 'column', ml: 1 }}>
        <Typography variant="h6" sx={{ p: 1.5, borderBottom: 1, borderColor: 'divider', flexShrink: 0 }}>
          {t('Order History')}
        </Typography>
        <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
          <List dense>
            {history.map((order) => (
              <ListItem key={order.id} divider alignItems="flex-start">
                <ListItemText
                  primary={
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                      <Typography variant="body2" fontWeight="medium">{order.id}</Typography>
                      <Chip label={order.status} color={getStatusColor(order.status)} size="small" />
                    </Box>
                  }
                  secondary={
                    <React.Fragment>
                      <Typography component="span" variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                        {order.date}
                      </Typography>
                      {order.items.map((item, index) => (
                        <Typography key={index} component="span" variant="body2" color="text.primary" sx={{ display: 'block', fontSize: '0.8rem' }}>
                          {`- ${item.quantity}x ${item.brand} ${item.model}`}
                        </Typography>
                      ))}
                      <Typography component="span" variant="body2" fontWeight="medium" color="text.primary" sx={{ display: 'block', textAlign: 'right', mt: 0.5 }}>
                        {`Total: $${order.total.toFixed(2)}`}
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem>
            ))}
            {history.length === 0 && (
              <ListItem>
                <ListItemText primary={t('No past orders found.')} sx={{ textAlign: 'center', color: 'text.secondary', py: 2 }} />
              </ListItem>
            )}
          </List>
        </Box>
      </Paper> */}
    </Box>
  );
};

export default VlnOrder;